export class PavillionColorViboxMetricModel {
    val;
    chroma;
    maxChroma;
    minChroma;
    gradeProbability;
}
export default class PavillionColorViboxMetric extends PavillionColorViboxMetricModel {
    constructor(model) {
        super();
        Object.keys(model).forEach((key) => {
            this[key] = model[key];
        });
    }
    get title() {
        if (!this.chroma) {
            return '';
        }
        let title = this.chroma.grade;
        let value = Math.round(this.chroma.position * 10) / 10;
        if (value >= 1) {
            value = this.chroma.position;
        }
        const [position] = `${value * 10}`.split('.');
        if (position && +position > 0) {
            title += `.${position}`;
        }
        return title;
    }
    // Temporary value for smooth transition between showing short title (H.6) and long title (H 80% | I 20%)
    // when decision to use short value will be made, we can remove this getter
    get titleFull() {
        const minChromaGrade = this.minChroma?.grade;
        const maxChromaGrade = this.maxChroma?.grade;
        const isSameGrade = minChromaGrade === maxChromaGrade;
        const shortTitle = this.title;
        if (!minChromaGrade || !maxChromaGrade) {
            return shortTitle || '';
        }
        const minChromaProbability = this.gradeProbability[minChromaGrade];
        const maxChromaProbability = this.gradeProbability[maxChromaGrade];
        let title = '';
        if (minChromaGrade && minChromaProbability) {
            title += `${minChromaGrade}${minChromaProbability}%`;
        }
        if (maxChromaGrade && maxChromaProbability && !isSameGrade) {
            if (title) {
                title += '|';
            }
            title += `${maxChromaGrade}${maxChromaProbability}%`;
        }
        return `${shortTitle} (${title})`;
    }
}
